!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

window.addEventListener("klaviyoForms", function(e) {

  function getParameterByNamesource(name) {
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var dropresults = regex.exec(window.location.search);

    if (!dropresults || !dropresults[1]) {
      return "";
    }

    return decodeURIComponent(dropresults[1].replace(/\+/g, " "));
  }

  if (e.detail.type == "submit") {
    var _learnq = window._learnq || [];
    var url_visit = window.location.pathname;
    var dropresult = getParameterByNamesource("utm_campaign");
    var dropresult2 = getParameterByNamesource("utm_source");

    _learnq.push(["identify", {
      "URL Visited": url_visit,
      "Drop Source": dropresult,
      "List Source": dropresult2
    }]);
  }

});